import { FC } from 'react';

import { IconDynamic, SquaresIntersectedSize16 } from '@hh.ru/magritte-ui/icon';

const RequestIdIcon: FC<{ requestId: string }> = ({ requestId }) => {
    return (
        <span>
            {requestId}
            &nbsp;
            <IconDynamic>
                <button
                    onClick={() => {
                        void navigator.clipboard.writeText(requestId);
                    }}
                >
                    <SquaresIntersectedSize16 initial="secondary" highlighted="primary" />
                </button>
            </IconDynamic>
        </span>
    );
};

export default RequestIdIcon;
